import { useRef, type MouseEvent } from 'react';

/**
 * Закрывать модалку только если и mousedown, и click были по подложке.
 * Иначе выделение/копирование в поле даёт click по overlay и окно схлопывается.
 */
export function useOverlayDismiss(onClose?: () => void) {
  const downOnOverlay = useRef(false);

  return {
    onMouseDown: (event: MouseEvent<HTMLDivElement>) => {
      downOnOverlay.current = event.target === event.currentTarget;
    },
    onClick: (event: MouseEvent<HTMLDivElement>) => {
      if (
        onClose &&
        downOnOverlay.current &&
        event.target === event.currentTarget
      ) {
        onClose();
      }
      downOnOverlay.current = false;
    },
  };
}
